export default __webpack_public_path__ + "static/media/decal-unaccept.72cfa909.png";